module.exports = __webpack_public_path__ + "static/media/arrow.415168b5.svg";